// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center{width:100px;height:100px}.close{position:absolute;top:50%;left:50%}", ""]);
// Exports
module.exports = exports;
